import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCustomerAction, useEllipsis, useGradient } from "@/hooks";
import { useThrottledWidthObserver } from "@/hooks/useThrottledWidthObserver";
import { useI18n } from "@/shared/hooks";
import { formatTextWithHtml } from "@/utils";
import { Box } from "@gemini/core";
import { useEffect, useState } from "react";
import { AnimatedChevronIcon } from "./AnimatedChevronIcon";
import { ExpandableTextEllipsisBtn } from "./ExpandableTextEllipsisBtn";
import { useTrackingShowMore } from "@/hooks/tracking/useTrackingShowMore";
import { InteractionEnum } from "@/types";
export const ExpandableText = ({ avZone, text, nbLines, testId, withGradient, }) => {
    const [isExpanded, setIsExpanded] = useState(Boolean(false));
    const { ref: ellipsisRef, ellipsisStyle, hasButton: hasEllipsisButton, } = useEllipsis(nbLines);
    const { ref: gradientRef, hasButton: hasGradiantButton, gradientStyle, } = useGradient(nbLines);
    const ref = withGradient ? gradientRef : ellipsisRef;
    const collapseStyle = withGradient && hasGradiantButton ? gradientStyle : ellipsisStyle;
    const { t } = useI18n();
    const seeMoreLabel = t("cta.see_more_v2");
    const buttonLabel = isExpanded ? t("cta.see_less") : seeMoreLabel;
    const LINE_HEIGHT = 16;
    const collapsedHeight = LINE_HEIGHT * nbLines;
    const [contentHeight, setContentHeight] = useState(collapsedHeight);
    const { customerActionLeadInteraction } = useCustomerAction();
    const handleTrackingShowMore = useTrackingShowMore(avZone);
    const trackCustomerActionSectionReadMore = (title) => {
        customerActionLeadInteraction(InteractionEnum.OPEN_MORE, title);
    };
    useEffect(() => {
        var _a;
        if (isExpanded) {
            setContentHeight((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
        }
        else {
            setContentHeight(collapsedHeight);
        }
    }, [isExpanded, ref, withGradient, contentHeight, collapsedHeight]);
    useThrottledWidthObserver(ref, () => {
        if (!isExpanded)
            setContentHeight(collapsedHeight);
    });
    const onPress = () => {
        if (!isExpanded && hasGradiantButton) {
            trackCustomerActionSectionReadMore(t("description.modal.title"));
            handleTrackingShowMore();
        }
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            ref.current.scrollIntoView({ behavior: "instant" });
            // eslint-disable-next-line no-restricted-globals
            window.scrollBy(0, -200);
        }
    };
    const renderAnimatedChevronIcon = (isExpanded) => (_jsx(AnimatedChevronIcon, { isExpanded: isExpanded }));
    const displayTextButton = (hasEllipsisButton && !withGradient) || (hasGradiantButton && withGradient);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { ref: ref, 
                // @ts-ignore
                unsafe_style: isExpanded ? null : collapseStyle, 
                // @ts-ignore
                dangerouslySetInnerHTML: { __html: formatTextWithHtml(text) }, transitionProperty: "height, max-height", transitionDuration: "unsafe_component.accordion.motionDuration", transitionTimingFunction: "unsafe_component.accordion.motionEasing", typography: "typography.body.14.regular", height: hasGradiantButton ? contentHeight : undefined, maxHeight: contentHeight, whiteSpace: "pre-line", width: "100%", testId: testId, unsafe_className: "DescriptionTexts", overflow: "hidden" }), displayTextButton && (_jsx(ExpandableTextEllipsisBtn
            // @ts-ignore
            , { 
                // @ts-ignore
                testId: testId, onPress: onPress, buttonLabel: buttonLabel, icon: () => renderAnimatedChevronIcon(isExpanded), 
                // @ts-ignore
                isGradientVersion: withGradient }))] }));
};
